module.exports = __webpack_public_path__ + "d1d406216a70e5eae70e4832af8057fe.pdf";